"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.EventActivityHeader = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _VirtualEventInfo = babelHelpers.interopRequireDefault(require("VirtualEventInfo"));

var _ExternalEventInfo = babelHelpers.interopRequireDefault(require("ExternalEventInfo"));

var _decorators = require("decorators");

var _AddEvent = babelHelpers.interopRequireDefault(require("AddEvent"));

var _class, _descriptor, _temp, _class3, _descriptor2, _descriptor3, _temp2, _class5, _descriptor4, _descriptor5, _temp3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Types = {
  virtualEvent: _VirtualEventInfo.default,
  externalEvent: _ExternalEventInfo.default
};

function show(event, element) {
  _reactDom.default.render(_react.default.createElement(EventActivityHeader, {
    event: event
  }), element);
}

var EventActivityHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventActivityHeader, _Component);

  function EventActivityHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, EventActivityHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(EventActivityHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "event", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(EventActivityHeader, [{
    key: "render",
    value: function render() {
      var Type = Types[this.event.type];
      return _react.default.createElement("div", {
        className: "event-activity-header"
      }, _react.default.createElement(Type, _extends({
        activityHeader: true
      }, this.event)), this.event.type == 'virtualEvent' && _react.default.createElement(VirtualEventJoin, {
        event: this.event
      }), _react.default.createElement(AddToCalendar, {
        event: this.event
      }));
    }
  }]);
  return EventActivityHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "event", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.EventActivityHeader = EventActivityHeader;
var VirtualEventJoin = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(VirtualEventJoin, _Component2);

  function VirtualEventJoin() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, VirtualEventJoin);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(VirtualEventJoin)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "event", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "endTime", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      buttonActive: _this2.event.start < Date.now() && _this2.endTime > Date.now()
    };
    return _this2;
  }

  babelHelpers.createClass(VirtualEventJoin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.endTime > Date.now()) this.startTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var period;
      if (this.event.start > Date.now()) period = this.event.start - Date.now();else if (this.endTime > Date.now()) period = this.endTime - Date.now();
      period = Math.min(period, 3600000);
      if (period > 0) this._timer = setTimeout(this.checkTimer, period);
    }
  }, {
    key: "checkTimer",
    value: function checkTimer() {
      var _this3 = this;

      this.setState({
        buttonActive: this.event.start < Date.now() && this.endTime > Date.now()
      }, function () {
        return _this3.startTimer();
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.event.unconfirmedDate) return null;

      if (this.endTime > Date.now()) {
        return _react.default.createElement("div", {
          className: "virtual-event-button"
        }, _react.default.createElement("a", {
          className: "btn btn-primary ".concat(this.event.virtual.link && this.state.buttonActive ? '' : 'disabled'),
          href: this.state.buttonActive && this.event.virtual.link ? this.event.virtual.link : 'javascript:void(0)',
          target: "_blank"
        }, "Join Now"), this.event.virtual.password && _react.default.createElement("div", {
          className: "event-password"
        }, "Password: ", _react.default.createElement("span", {
          className: "password"
        }, this.event.virtual.password)));
      }

      if (this.event.recording) {
        return _react.default.createElement("div", {
          className: "virtual-event-button"
        }, _react.default.createElement("a", {
          className: "btn btn-primary",
          href: "javascript:void(0)",
          onClick: this.watchRecording
        }, "Watch Recording"));
      }

      return null;
    }
  }, {
    key: "watchRecording",
    value: function watchRecording(event) {
      event.preventDefault();
      var _this$event$recording = this.event.recording,
          type = _this$event$recording.type,
          content = _this$event$recording.content;

      switch (type) {
        case 'link':
          if (content.newWindow) {
            window.open(content.url, '_blank');
          } else {
            require('layouts/SiteLayout').default.current.navigate(content.url);
          }

          return;

        case 'embed':
          var Player = require('VideoPlayer').EmbedPlayerModal;

          new Player({
            embedCode: content
          }).show();
          return;

        case 'video':
          var VideoPlayer = require('VideoPlayer').default;

          var player = new VideoPlayer({
            lazy: content
          });
          player.showVideo();
          return false;
      }
    }
  }]);
  return VirtualEventJoin;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "event", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "endTime", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.event.end == this.event.start ? 3600000 + this.event.start : this.event.end;
  }
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "checkTimer", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "checkTimer"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "watchRecording", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "watchRecording"), _class3.prototype)), _class3);
var AddToCalendar = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(AddToCalendar, _Component3);

  function AddToCalendar() {
    var _babelHelpers$getProt3;

    var _this4;

    babelHelpers.classCallCheck(this, AddToCalendar);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(AddToCalendar)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "event", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "endTime", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(AddToCalendar, [{
    key: "render",
    value: function render() {
      return this.event.unconfirmedDate || this.endTime < Date.now() ? null : _react.default.createElement(_AddEvent.default, _extends({}, this.event.addEvent, {
        buttonTitle: "Add to Calendar"
      }));
    }
  }]);
  return AddToCalendar;
}(_react.Component), _temp3), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "event", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "endTime", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.event.end == this.event.start ? 3600000 + this.event.start : this.event.end;
  }
})), _class5);